<template>
    <div>
        <naj-box :title="local.caseRelatedRequest.ReconsiderationRequest.title">
            <v-row>
                <v-col cols="3">
                    <naj-input :type-id="formFieldType.selectbox"
                               :value.sync="formModel.judgementCode"
                               :label="local.caseRelatedRequest.ReconsiderationRequest.judgementCode"
                               :items="judgments"
                               item-value="judgementCode"
                               item-text="judgementCode"
                               :validates="`required`"
                               :disabled="isViewMode || isEditMode"
                               @change="setSelectedJudgment">
                    </naj-input>
                </v-col>
                <v-col cols="1"
                       class="judgement-deed">
                    <naj-button :disabled="!selectedJudgment.objectKey"
                                @click="getJudgementDeed">
                        {{ local.caseRelatedRequest.ReconsiderationRequest.displayJudgement }}
                    </naj-button>
                </v-col>
                <v-col cols="6">
                    <naj-input :type-id="formFieldType.date"
                               :label="local.caseRelatedRequest.ReconsiderationRequest.noticeDate"
                               :value.sync="formModel.noticeDate"
                               validates="required"
                               :disabled="isViewMode"></naj-input>
                    <p class="noticeDate-text">
                        {{ local.caseRelatedRequest.ReconsiderationRequest.noticeDateText }}
                    </p>
                </v-col>
            </v-row>
        </naj-box>
        <case-judgement-modal :selected-judgement="selectedJudgment"
                              :modal-visibility="showCaseJudgementModal"
                              @modalClose="closeCaseJudgementModal"></case-judgement-modal>
        <naj-alert-modal :show-modal="showAlertModal"
                         type="information"
                         :title="local.caseFile.secretJudgementsInfoTitle"
                         :message="local.caseFile.secretJudgementsInfo"
                         @onCancelModal="showAlertModal=false">
        </naj-alert-modal>
    </div>
</template>

<script>
    import { mode, socialIdentityTypeEnum, countriesEnum } from '@/helpers/enum';
    import { createNamespacedHelpers } from 'vuex';
    const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
    const { mapActions } = createNamespacedHelpers('CasesModule');
    import CaseJudgementModal from '../../../../cases/case-judgement-modal';
    import { formatGeorgianEnDateString } from '@/helpers/utils';

    export default {
        name: 'ReconsiderationRequest',
        inject: ['$validator'],
        components: { CaseJudgementModal },
        props: {
            formModel: {
                type: Object,
                default: () => ({}),
            },
            requiredData: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
                judgments: [],
                caseParties: [],
                showCaseJudgementModal: false,
                showAlertModal: false,
                selectedJudgment: {},
                formatGeorgianEnDateString,
                najInputDateFormat: 'YYYY-MM-DD',
                outputDateFormat: 'MM/DD/YYYY',
            };
        },
        computed: {
            ...mapGlobalState(['userInfo']),
            isViewMode() {
                return this.formModel && this.formModel.mode === mode.view;
            },
            isEditMode() {
                return this.formModel && this.formModel.mode === mode.update;
            },
            isNewMode() {
                return this.$route.params.requestObjectKey === 'new';
            },
        },
        watch: {
            'formModel.noticeDate': function (value) {
                if (value) {
                    this.$set(this.formModel, 'date', formatGeorgianEnDateString(this.formModel.noticeDate, this.najInputDateFormat, this.outputDateFormat));
                }
            },
        },
        mounted() {
            if (this.formModel) {
                if (this.formModel.judgementCode) {
                    this.setSelectedJudgment();
                }
                this.readCurrentUserInfo();
            }

            if (this.formModel && this.formModel.date) {
                this.$set(this.formModel, 'noticeDate', formatGeorgianEnDateString(this.formModel.date, this.outputDateFormat, this.najInputDateFormat));
            }

            this.loading = true;
            const params = {
                isPega: this.formModel.isPega,
                objectKey: this.formModel.case.objectKey,
            };

            Promise.all([
                this.getCaseJudgments(params),
                this.getCaseBasicParties(params),
            ])
                .then((res) => {
                    this.judgments = res[0].data;
                    this.setSelectedJudgment();

                    this.caseParties = res[1].data;
                })
                .finally(() => (this.loading = false));
        },
        created() {
        },
        methods: {
            ...mapActions([
                'getCaseJudgments',
                'getCaseBasicParties',
                'isValidApplicantForCommercialJudgement',

            ]),
            setSelectedJudgment() {
                this.formModel.judgementCode && this.$set(this, 'selectedJudgment', (this.judgments || []).find(a => a.judgementCode == this.formModel.judgementCode) || {});

                if (this.formModel.judgementCode !== undefined) {
                    this.loading = true;
                    this.isValidApplicantForCommercialJudgement(this.formModel.judgementCode)
                        .then(() => {
                            this.$set(this.formModel, 'isApplicantEligibleToApply', true);
                        })
                        .catch(() => {
                            this.$set(this.formModel, 'isApplicantEligibleToApply', false);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    this.$set(this.formModel, 'isApplicantEligibleToApply', undefined);
                }

            },
            getJudgementDeed() {
                if (this.selectedJudgment.isSecretJudgements) {
                    this.showAlertModal = true;
                } else {
                    this.showCaseJudgementModal = true;
                }
            },
            closeCaseJudgementModal() {
                this.showCaseJudgementModal = false;
            },
            readCurrentUserInfo() {
                if (this.userInfo) {
                    const socialTypeId = this.userInfo.socialIdType;
                    this.$set(this.formModel, 'socialIdType', socialTypeId);
                    this.$set(this.formModel, 'socialId', this.userInfo.socialId);
                    this.$set(this.formModel, 'firstName', this.userInfo.firstName);
                    this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
                    this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
                    this.$set(this.formModel, 'familyName', this.userInfo.familyName);
                    this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
                    this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
                    this.$set(this.formModel, 'sex', this.userInfo.gender);
                    this.$set(this.formModel, 'isRetrievedFromMoi', true);
                    this.$set(this.formModel, 'fullName', this.userInfo.fullName);
                } else {
                    this.$set(this.formModel, 'socialIdType', null);
                    this.$set(this.formModel, 'socialId', null);
                    this.$set(this.formModel, 'firstName', null);
                    this.$set(this.formModel, 'fatherName', null);
                    this.$set(this.formModel, 'grandFatherName', null);
                    this.$set(this.formModel, 'familyName', null);
                    this.$set(this.formModel, 'dateOfBirth', null);
                    this.$set(this.formModel, 'nationalityCountryId', null);
                    this.$set(this.formModel, 'sex', null);
                    this.$set(this.formModel, 'isRetrievedFromMoi', false);
                    this.$set(this.formModel, 'fullName', null);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .judgement-deed {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ::v-deep .attachment-item {
        cursor: pointer;
    }

    .noticeDate-text {
        color: darkred;
        font-size: 1rem;
        margin-bottom: 0;
    }
</style>